
import VueTurnstile from '@/components/turnstile/VueTurnstile.vue'
import { defineComponent, ref } from 'vue'
import { request, ResponseType } from '@/utils/api';
import { sign } from '@/utils/encrypt'
import Constants from '@/constant/constants';
import { ElLoading } from 'element-plus';

export default defineComponent({
  name: 'App',
  components: {
    VueTurnstile,
  },
  setup() {
    const token = ref('')
    const isVerifySuccess = ref(false)
    const turnstileRef = ref<any>(null);

    const onSuccessHandle = async (e: string) => {
      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const header = { [Constants.Sign.key]: sign() };
      let res: ResponseType<boolean> | null = null;
      try {
        const origin = window.location.origin;
        res = await request('POST', { token: e }, origin + "/api/stockroom/cf-turnstile-verify/", header);
      } catch (error) {
        console.log("Server Verify Turnstile error ", error);
      }
      if (res && res.data) {
        console.log("Verify Turnstile on success.");
        isVerifySuccess.value = true;
      } else {
        console.log("Verify Turnstile failed.");
        turnstileRef.value.reset();
      }
      loading.close();
    }
    return {
      token,
      isVerifySuccess,
      onSuccessHandle,
      turnstileRef
    }
  }
})
